import setCounters from './setCounters';
import setTriageRequests from './setTriageRequests';
import setMoreTriageRequests from './setMoreTriageRequests';
import setTriageRequest from './setTriageRequest';
import reset from './reset';
import resetTriageRequest from './resetTriageRequest';
import setUpdatedBloodPressureReading from './setUpdatedBloodPressureReading';

export default {
  setCounters,
  setTriageRequests,
  setMoreTriageRequests,
  setTriageRequest,
  reset,
  resetTriageRequest,
  setUpdatedBloodPressureReading,
};
